import { render, staticRenderFns } from "./StepShopifyPlan.vue?vue&type=template&id=8fa5c86c&"
import script from "./StepShopifyPlan.vue?vue&type=script&lang=js&"
export * from "./StepShopifyPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports